import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="176.752"
      height="308.626"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 176.752 308.626"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-712.413 -789.874)"
      >
        <path
          strokeWidth="1"
          d="M720.17 960.428c-2.162-1.596-2.723-5.786-3.028-7.617-.927-5.562-.668-12.367-.668-18.04 0-5.36-2.069-7.934-2.81-13.121-.677-4.742-.961-9.808-.581-14.726.407-5.286.48-10.098 1.304-15.257 1.27-7.956 4.047-17.969 4.793-21.374 1.439-6.566 4.96-13.549 7.613-19.779 1.381-3.243 4.235-9.958 3.271-14.821-.562-2.832-.377-5.098-.236-5.694 1.251-5.3 3.178-5.085 3.589-9.231.099-.997.579-2.909.422-4.894-.221-2.794-.917-5.72.757-6.394.84-.338 2.198-.6 2.794-.205 2.218 1.47 2.856 7.481 5.411 6.991.756-.145 1.389-1.135 1.877-1.78.985-1.302.856-3.166 1.171-4.682.514-2.466-.985-12.965 3.697-12.221 1.241.197 1.93 1.791 1.989 3.764.087 2.948-.278 6.948-.192 8.345.041.667-.083 3.927.018 3.987.727.433 2.71-.745 3.534-2.153 1.208-2.064 2.248-5.063 2.514-5.854.994-2.958 2.511-6.244 3.683-9.131 1.15-2.834 2.122-5.168 3.896-5.882 2.268-.914 3.281.441 3.263 2.265-.021 2.109-1.125 5.166-1.611 6.368-.544 1.348-4.003 8.183-5.884 12.96-.905 2.298-1.665 4.208-1.143 4.635 1.025.84 3.229-2.421 3.884-3.218 2.967-3.608 5.305-8.62 7.761-12.211.383-.56 2.76-3.606 4.767-3.061 1.268.345.776 4.285-.191 6.618-.561 1.356-2.932 6.444-3.839 7.867-2.788 4.372-5.544 9.292-9.729 16.136-.926 1.516-.083 8.023.729 7.93 4.759-.545 7.543-1.32 10.717-2.504.764-.285 3.333-1.543 5.55-1.996 1.652-.338 3.243.043 3.56.9.209.564.554 1.042-.481 2.411-1.423 1.88-5.899 3.579-7.909 4.79-5.075 3.057-10.66 5.377-16.2 7.608-1.406.566-10.463 1.997-10.767 2.71l.002.011c-3.157 6.315-5.733 26.608-4.318 33.684.601 3.006.862 7.655.423 10.729-.674 4.717-1.607 10.315-1.637 15.19-.018 2.763 1.988 4.567 3.737 7.472 1.739 2.89 1.991 5.946 2.28 8.415.143 1.221.375 3.624.88 5.532.4 1.514 1.108 2.728 1.119 2.707"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M879.485 938.027c-1.595-2.587-4.287-5.581-5.274-8.771-1.431-4.621-3.187-9.558-6.177-13.393-1.156-1.482-2.596-2.908-4.039-3.937-3.082-2.196-5.51-2.975-8.825-3.701-1.891-.414-3.947-.15-5.841-.815-.718-.253-3.038-1.849-4.925-4.104-.698-.833-.133-2.584-3.264-6.256m-56.11 1.803s-.505.638-1.144 1.016c-.639.377-1.457.332-1.457.332-3.005-.244-6.072 3.996-6.673 5.421-2.706 6.408-3.918 13.052-3.132 20.503.325 3.085 3.492 8.183 6.645 8.794 1.187.23 4.575.59 5.973.334 0 0-.308 3.396-.921 6.222-.613 2.825-1.531 5.08-1.531 5.08"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M818.333 958.642c.108-.528.331-2.541.718-3.654.491-1.414 1.481-3.116 2.166-4.654.838-1.883 1.311-3.554 2.52-4.244 1.43-.817 2.777.228 4.485.88 1.269.484 3.669 1.149 5.825 1.43 1.253.164 3.306.162 3.726-.381.433-.559.632-.827 1.581-1.023 1.551-.32 4.479-.114 6.104-.1 2.366.022 4.995.217 7.182.738 2.387.569 4.391 1.645 6.226 2.721 3.405 1.997 5.009 3.783 6.998 5.534"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M874.307 965.292c-.042-.003 1.395 1.997 2.486 3.31"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M886.052 946.206c.944 1.095 1.645 1.868 2.613 3.049"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M880.213 973.005c.344.472 3.599 5.413 3.524 5.576-.071.155-6.229.208-8.372-.023"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M867.282 976.464c-5.189-1.152-21.106-3.321-25.918-2.519-1.872.312-2.451 1.624-4.183 1.624-.58 0-2.178-3.402-3.519-5.24-1.34-1.837-5.101-2.537-7.373-3.225-4.127-1.251-7.772-7.669-7.772-7.669-4.243 6.413-20.157 5.231-25.659 1.391-7.793-5.44-10.102-11.608-10.894-13.071 0 0-2.333 2.532-5.506 3.772-3.349 1.309-7.79.659-8.914.51-2.843-.378-3.138-2.805-4.696-4.842-1.628-2.127-5.506-4.876-7.764-6.237-.663-.399-4.805-5.545-4.941-5.478-.98.482-1.635 3.579-1.778 4.658-.423 3.185-2.926 6.537-5.405 8.52-4.35 3.479-9.01 6.717-14.136 8.934-2.328 1.007-7.055 1.49-8.49 3.492-1.062 1.48.185 3.171-.017 4.689-.485 3.647-1.536 7.756-.761 11.375.325 1.52 2.592 6.249 2.592 6.249s1.206 4.328 1.497 5.696c1.072 5.035-.075 10.24-.732 16.187-.756 6.84-2 14.88-1.362 28.41.637 13.53 6.417 36.42 6.36 43.93"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M886.335 1026.57c-5.024.12-15.611-4.61-19.858-2.1-1.662.98-2.57 2.49-4.386 3.24-4.717 1.96-6.688-1.07-10.497 1.79-2.101 1.57-6.721 13.07-7.526 15.99-1.242 4.51-2.877 9.53-3.58 14.24-.676 4.53-.034 8.75-.932 13.27-.428 2.17-.505 4.33-1.374 6.18-.584 1.24-1.258 3.59-1.535 4.99-.886 4.47-.244 8.39.07 12.83"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M844.159 937.939c.578-2.443 1.606-6.334 2.815-8.494.672-1.199 1.515-1.628 2.2-.986.91.852 1.566 3.192 1.413 4.215-.305 2.05-4.836 4.662-6.428 5.265z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M778.392 951.646c.014-.109 2.85 12.403 19.256 16.569 15.833 4.021 22.895-4.938 22.895-4.938"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M785.301 899.618s-4.079-16.161 7.208-27.918c3.155-3.286 3.545-2.793 6.086-4.101 2.541-1.307 2.473-.374 4.077-1.129 1.603-.754 1.254-1.572 2.336-1.89 4.084-1.199 9.066-1.402 14.968-.757.916.1 1.274 1.278 2.039 1.459 4.164.985 3.847.597 6.6 1.877 4.655 2.165 8.423 7.604 11.255 13.099 1.32 2.562 2.211 5.292 3.304 7.426 1.255 2.447 2.063 3.151 2.063 3.151s-11.038-6.03-35.966 2.453c-12.286 4.181-14.91 7.864-14.91 7.864z"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M807.493 894.334s14.95 1.101 29.93 2.027c9.129.565 18.538.281 23.798 1.918 7.602 2.366 4.272 7.966.51 9.334-3.762 1.368-16.702-4.374-16.702-4.374"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M845.598 891.063s2.522 1.351 6.899 3.344c4.377 1.992 10.61 4.627 10.61 4.627"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;